// Personal actions
export const PERSONAL_CREATE = 'PERSONAL_CREATE';
export const PERSONAL_CREATED = 'PERSONAL_CREATED';
export const PERSONAL_UPDATE = 'PERSONAL_UPDATE';
export const PERSONAL_PREPARE = 'PERSONAL_PREPARE';
export const PERSONAL_UPDATED = 'PERSONAL_UPDATED';